<template>
  <Header :path="path"/>
  <section class="c-section">
    <div class="c-section__content">
      <h2 class="c-section__heading">About</h2>
        <p>I am a Senior Full-Stack Developer with a {{totalExperience}} track record of delivering responsive, interactive, and enterprise-grade web solutions. From architecting decoupled systems to implementing high-performance frontends, I thrive on solving complex technical challenges and optimizing development processes.</p>
        <p>Constantly evolving with the tech landscape, I integrate emerging AI technologies into my workflow to drive innovation and efficiency. My goal is always to build digital products that are not only functional but also future-proof and user-centric.</p>
        <p>Want to discuss a project? Follow me on <strong><a href="https://www.linkedin.com/in/billy-han-1a253976/" target="_blank">Linkedin</a></strong> or send me an <strong><a href="mailto:nada_billy0217@hotmail.com">email</a></strong></p>
        <p><a href="https://github.com/billy0217/" target="_blank" class="c-icon-link"><i class="iconf-github c-icon-link__icon"></i>GitHub Repo</a></p>
        <p><a href="https://codepen.io/billy0217/pens/public" target="_blank" class="c-icon-link"><i class="iconf-codepen c-icon-link__icon"></i>CodePen Play Ground</a></p>
    </div>
  </section>
  <Footer />
</template>

<script>
// @ is an alias to /src
import { ref } from 'vue';
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'Home',
  components: {
    Header,
    Footer
  },
  setup(){
    const totalExperience = ref(null);

    //let df= new Date("6/14/2013");
    let df= new Date("2013");
    let dt = new Date();
    let allMonths= dt.getMonth() - df.getMonth() + (12 * (dt.getFullYear() - df.getFullYear()));
    let allYears= dt.getFullYear() - df.getFullYear();
    let partialMonths = dt.getMonth() - df.getMonth();
    let months;
    if (partialMonths < 0) {
        allYears--;
        partialMonths = partialMonths + 12;
    }

    if( 0 < allYears ){
      allYears += ' years';
    }

    if( 1 <= partialMonths){
      months = " and " + partialMonths + " months"
    }else{
      months = "";
    }

    totalExperience.value = allYears;

    return {totalExperience};

  },
  data(){
    return {
      path: this.$route.name,
    }
  }
}
</script>

